export function toggleTopHeader() {
    if (!document.getElementById('top-header') || !document.getElementById('top-header-button'))
    return;
    
    const button = document.getElementById('top-header-button'); 
    const topHeader = document.getElementById('top-header');
    const navigation = document.getElementById('navbar');

    let clickFlag = false;

    button.addEventListener('click', function (event) {
        if (!clickFlag) {
            var clickedButton = this;
            clickFlag = true;
            topHeader.classList.toggle('show');
            clickedButton.classList.toggle('show');
            navigation.classList.toggle('add-margin');

            setTimeout(() => {
                clickFlag = false;
            }, 300);
        }
    });
}